export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 * Validates whether a URL is safe.
 * Returns the trimmed URL if valid, or null if invalid/unsafe.
 * Protects against XSS (javascript:, data:, vbscript:) and Open Redirects.
 *
 * @param {string} url - Target URL to validate.
 * @param {boolean} [allowRelative=true] - Whether to allow internal relative paths.
 * @returns {string|null} Safe URL or null.
 */
export function validateUrl(url, allowRelative = true) {
  if (!url || typeof url !== 'string') return null;

  const trimmed = url.trim().replace(/^[\u0000-\u0020]+/g, '');
  if (!trimmed || /^(?:javascript|data|vbscript):/i.test(trimmed)) {
    return null;
  }

  if (allowRelative) {
    if (trimmed.startsWith('/') && !trimmed.startsWith('//')) {
      return trimmed;
    }
    if (trimmed.startsWith('#') || trimmed.startsWith('?')) {
      return trimmed;
    }
  }

  try {
    if (trimmed.startsWith('//')) return null;
    const parsed = new URL(trimmed, window.location.origin);
    if (['http:', 'https:'].includes(parsed.protocol.toLowerCase())) {
      return trimmed;
    }
  } catch (e) {
    return null;
  }

  return null;
}
